import SvgIcon from '@ixigo/icons/SvgIcon';
import cn from '../utils/cn';

export const Invoice = (props: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<SvgIcon
			className={cn(props.className)}
			data-testid="InvoiceIcon"
			width="161"
			height="160"
			viewBox="0 0 161 160"
			fill="none"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M45.0029 46.5C45.0029 35.7304 53.735 27 64.5064 27H112.997C123.768 27 132.5 35.7304 132.5 46.5V116.5C132.5 125.06 125.559 132 116.997 132H47.5034C37.0081 132 28.5 123.493 28.5 113C28.5 102.507 37.0081 94 47.5034 94H102.471C105.703 94 107.52 96.6697 108.139 98.8034C108.765 100.966 108.63 103.997 106.531 105.982C103.97 108.404 102.513 110.811 102.513 113C102.513 120.732 109.264 127 116.997 127C122.797 127 127.499 122.299 127.499 116.5V46.5C127.499 38.4919 121.006 32 112.997 32H64.5064C56.4969 32 50.0038 38.4919 50.0038 46.5V86.5C50.0038 87.8807 48.8844 89 47.5034 89C46.1224 89 45.0029 87.8807 45.0029 86.5V46.5ZM103.668 127C99.8842 123.527 97.5123 118.54 97.5123 113C97.5123 108.689 100.254 105.036 103.094 102.349C103.346 102.111 103.658 101.309 103.335 100.195C103.004 99.0514 102.475 99 102.471 99H47.5034C39.77 99 33.5009 105.268 33.5009 113C33.5009 120.732 39.77 127 47.5034 127H103.668Z"
				fill="#0770E4"
			/>
			<path
				d="M101.669 74.5L58.8491 74.4999C57.4681 74.4999 56.3486 75.6192 56.3486 76.9999C56.3486 78.3806 57.4681 79.4999 58.849 79.4999L101.669 79.5C103.05 79.5 104.17 78.3807 104.17 77C104.17 75.6193 103.05 74.5 101.669 74.5Z"
				fill="#0770E4"
			/>
			<path
				d="M58.8491 68.5222C57.4681 68.5222 56.3486 67.4029 56.3486 66.0222C56.3486 64.6415 57.4681 63.5222 58.8491 63.5222L90.1894 63.5222C91.5703 63.5222 92.6898 64.6415 92.6898 66.0222C92.6898 67.4029 91.5703 68.5222 90.1894 68.5222L58.8491 68.5222Z"
				fill="#0770E4"
			/>
			<path
				d="M65.0667 57.1405C69.6266 57.1405 73.3157 53.4485 73.3157 48.8906C73.3157 44.3327 69.6266 40.6407 65.0667 40.6407C60.5068 40.6407 56.8176 44.3327 56.8176 48.8906C56.8176 53.4485 60.5068 57.1405 65.0667 57.1405Z"
				fill="#FC790D"
			/>
		</SvgIcon>
	);
};

export default Invoice;
